var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeganDiet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122 134",
    width: 24,
    height: 24,
    className: "ml-n5 mr-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "Filter_diet_nav_11",
    x: "-20px",
    y: "-15px",
    width: "164px",
    height: "178px"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    dx: 0,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0, 0, 0)",
    result: "floodOut"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "atop",
    in: "floodOut",
    in2: "blurOut"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.12
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Filter_diet_nav_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(85, 116, 128)",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    d: "M83.222,120.997 C83.222,120.997 74.932,120.325 69.173,111.190 C63.415,102.056 61.495,99.011 61.495,99.011 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "3px",
    stroke: "rgb(84, 116, 128)",
    fill: "rgb(255, 255, 255)",
    d: "M92.331,68.661 C86.414,81.956 80.885,96.188 78.228,105.873 L77.059,108.273 C73.050,115.794 63.407,118.546 55.522,114.419 C48.763,110.883 45.505,103.443 47.232,96.653 C48.307,89.210 53.695,75.371 61.724,60.308 C70.230,44.351 79.719,33.855 85.497,30.503 C93.314,25.369 106.552,22.229 112.692,25.442 C114.518,26.398 114.849,28.345 114.340,30.802 C107.970,38.598 98.904,53.895 92.331,68.661 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "8px",
    stroke: "rgb(237, 237, 237)",
    fill: "rgb(237, 237, 237)",
    d: "M48.838,54.304 C57.496,66.026 67.167,77.882 74.301,85.003 L75.814,87.206 C80.381,94.405 77.962,104.055 70.411,108.761 C63.940,112.794 55.809,111.872 50.739,106.998 C44.772,102.357 35.373,90.816 26.226,76.397 C16.438,60.967 12.029,47.473 12.081,40.913 C11.563,31.651 15.412,18.874 21.255,15.232 C23.003,14.143 24.871,14.832 26.763,16.497 C30.389,25.859 39.222,41.284 48.838,54.304 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "3px",
    stroke: "rgb(84, 116, 128)",
    fill: "rgb(156, 255, 126)",
    d: "M99.827,43.340 L98.444,45.223 C96.154,48.341 91.736,49.062 88.576,46.833 C85.417,44.605 84.712,40.269 87.003,37.151 L88.385,35.269 C90.676,32.150 95.094,31.429 98.254,33.658 C101.413,35.887 102.117,40.222 99.827,43.340 ZM89.945,58.603 L88.726,60.988 C86.706,64.939 81.873,66.538 77.930,64.559 C73.987,62.581 72.428,57.775 74.448,53.824 L75.667,51.439 C77.686,47.488 82.520,45.889 86.462,47.868 C90.405,49.846 91.964,54.653 89.945,58.603 ZM80.914,76.510 L79.944,79.145 C78.338,83.511 73.504,85.775 69.147,84.202 C64.790,82.629 62.560,77.815 64.166,73.449 L65.136,70.814 C66.742,66.449 71.576,64.185 75.933,65.758 C80.290,67.330 82.520,72.145 80.914,76.510 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "3px",
    stroke: "rgb(84, 116, 128)",
    fill: "rgb(156, 255, 126)",
    d: "M49.161,62.832 C57.819,74.555 67.490,86.411 74.624,93.532 L76.137,95.735 C80.704,102.933 78.285,112.584 70.734,117.289 C64.263,121.322 56.132,120.401 51.062,115.526 C45.096,110.885 35.696,99.345 26.549,84.926 C16.761,69.496 12.352,56.002 12.404,49.441 C11.886,40.179 15.735,27.402 21.578,23.761 C23.326,22.671 25.194,23.361 27.086,25.025 C30.712,34.388 39.545,49.813 49.161,62.832 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeganDiet);
export default __webpack_public_path__ + "static/media/VeganDiet.4193dd69a6d9e9754c48d6d593f4f31e.svg";
export { ForwardRef as ReactComponent };